import { useMutation, UseMutationOptions } from "react-query";
import { fetchApi } from "@/helpers/reactQueryApi.ts";

type AssignChannelSubscriptionsArgs = {
  members: { id: string; type: string }[] | null;
  channels: string[];
  subscribe_all_network_members: boolean;
};

export function useAssignChannelSubscriptions(
  options?: UseMutationOptions<unknown, Error, AssignChannelSubscriptionsArgs>,
) {
  return useMutation<unknown, Error, AssignChannelSubscriptionsArgs>(
    (body: AssignChannelSubscriptionsArgs) =>
      fetchApi(
        "/administration/channel_assignments/assign_channel_subscriptions",
        { method: "POST", body },
      ),
    options,
  );
}
